import(/* webpackMode: "eager" */ "/app/assets/images/error-images/fancy.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/error-images/NoTeamsFound.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/error-images/overview.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/error-images/table.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/icon/bat.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/icon/humidity.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/icon/pace.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/icon/wind-speed.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/placeholder/pitch.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/placeholder/team.png");
;
import(/* webpackMode: "eager" */ "/app/assets/images/placeholder/weather.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/team-ic.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/accordian/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/ads/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/commonNav/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/customLink/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/fantasyOverview/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/match/fancy/fancyList/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/match/matchDetailCommentary/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/match/matchDetailLiveStats/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/match/matchDetailOvers/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/match/matchDetailOverview/headToHead/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/match/matchDetailOverview/teamComparision/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/match/matchDetailScorecard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/match/matchHeader/headerWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/match/odds/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/myImage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/playingXI/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/series/standings/standingTable/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/venuesContent/venueBowling/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/venuesContent/venueMatch/card/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/venuesContent/venueWin/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/widgets/probability/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/widgets/trendingPlayer/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/google-ads/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/revive-ads/index.tsx");
